module.exports = __webpack_public_path__ + "static/img/help.148d535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/images/help.png
// module id = 8rhx
// module chunks = 80